/**
 * EditorField — labeled text input
 */

interface EditorFieldProps {
  label: string;
  value: string | null | undefined;
  onChange: (value: string) => void;
  placeholder?: string;
  type?: string;
}

export function EditorField({ label, value, onChange, placeholder, type = 'text' }: EditorFieldProps) {
  return (
    <div className="field">
      <label className="field-label">{label}</label>
      <input
        className="field-input"
        type={type}
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
      />
    </div>
  );
}
